/* tslint:disable:component-selector import-spacing no-trailing-whitespace no-inferrable-types typedef-whitespace */
import {
  AfterViewInit,
  Component,
  ViewChild
} from '@angular/core';

import {Logger}                  from '@/util/logger';

import * as $ from 'jquery';
import 'gasparesganga-jquery-loading-overlay';

import {
  BehaviorSubject,
  Subscription
}                                from 'rxjs';

import {ServiceManager}          from "@/services/service.manager";
import {DocumentWindowManager}   from "@/screens/ide/document.window.manager";
import {RegressionViewerWindow}  from "@/screens/ide/regression.viewer.window";
import {WindowType}              from "@/screens/ide/window";
import {DocumentWindow}          from "@/screens/ide/document.window";

import {RegressionViewer}         from "@/screens/ide/regressionviewer/regression.viewer";
import {RegressionViewerMetadata} from "@/screens/ide/regression.viewer.metadata";

@Component({
  selector: 'regression-viewer-component',
  template: `

    <!-- outer shell for regression viewer -->
    <div class="regression-viewer-shell" style="text-align:center">
      <regression-viewer
        uuid={{u}} id="rv_{{u}}"
        (ready)="viewReady($event);"
      >

      </regression-viewer>
    </div>
  `
})

export class RegressionViewerComponent implements AfterViewInit {

  /* for uniq'ifying our drop #id's */

  public static  instanceNum:    number = 0;
  public u: number = RegressionViewerComponent.instanceNum;

  /** common access to the various services */
  public services: ServiceManager       = null;

  /** the error feedback if required */
  public       errorLine: string        = '';

  /** bubble up a 'ready' event once AGGrid is ready for use. */
  public ready                          = new BehaviorSubject<boolean>(false);

  @ViewChild(RegressionViewer,  {static: false})
  public viewer: RegressionViewer;

  /** toggle flag for this window being the anchor (default) window for this kind of window */
  public anchored: boolean              = false;

  /** the document manager controller; where we register for anchoring etc. */
  public manager: DocumentWindowManager = null;

  public window: RegressionViewerWindow      = null;

  /** the observable we use to know when some other window has taken the anchor */
  private anchorSub: Subscription;

  /* general call back for when we reload */

  public reloaded: () => void;

  /** standard constructor */
  constructor(
    services: ServiceManager
  ) {

    Logger.debug('[RegressionViewerComponent] dynamically creating...');

  }

  ngAfterViewInit(): void {

    const          u: number = RegressionViewerComponent.instanceNum;
    const instanceId: string = `rv_${this.u}`;

    Logger.debug(`[RegressionViewerComponent] setting up id=${instanceId}...`);

    /* before we can do anything we need to establish which viewer is for this component ... */

    if (!this.viewer) {

      Logger.error(`[RegressionViewerComponent] can't connect to view viewer for this instance (${u}).`);

    } else {

      Logger.debug(`[RegressionViewerComponent] instance ${u} connected to viewer:`, this.viewer);
    }


    RegressionViewerComponent.instanceNum++;
  }

  /** when the child view (which uses AGGrid) is ready, we tell the rest of the application we are ready. */
  public viewReady(event) {

    Logger.debug(`[RegressionViewerComponent] component is ready for use.`, event);

    this.ready.next(true);
  }

  /** both parent window and this component are ready, so any final setup */
  public finalize() {

    Logger.debug(`[RegressionViewerComponent] rv_${this.u} finalizing...`);

    let rvc: RegressionViewerComponent = this;

    rvc.anchorSub = rvc.manager.anchorSub.subscribe((anchor: {kind: WindowType, window: DocumentWindow}) => {

      if (anchor.kind == WindowType.None) {

        return ;
      }

      if (anchor.kind != rvc.window.type) {

        /* can ignore not our kind of window */

        return ;
      }

      /* null means our group anchor was cleared, otherwise one of the windows took the anchor */

      if (anchor.window != null) {

        if (anchor.window.id() == rvc.window.id()) {

          /* can ignore self */

          return ;
        }

      }

      /* either cleared or another window took anchor, we have to set anchored to false */

      Logger.debug(`[RegressionViewerComponent] rv_${this.u} cleared / other window took anchor.`);

      this.anchored = false;
    });

  }

  /** windows than can act as an anchor (default) window for their group/kind can "drop anchor" */
  public dropAnchor() {

    if (this.anchored == true) {

      return;
    }

    Logger.debug(`[RegressionViewerComponent] rv_${this.u} dropping anchor`);

    /* tell the doc manager we're the default window of this kind */

    this.manager.dropAnchor(WindowType.RegressionViewer, this.window)
    this.anchored = true;
  }

  /** opposite of dropping anchor, group/kind of windows will not have an anchor unitl another one is dropped. */
  public raiseAnchor() {

    if (this.anchored == false) {

      return;
    }

    /* tell the doc manager there is no default window of this kind */

    Logger.debug(`[RegressionViewerComponent] rv_${this.u} raising anchor`);

    this.manager.raiseAnchor(WindowType.RegressionViewer);

    this.anchored = false;
  }

  public toggleAnchor() {

    if (this.anchored == true) {

      this.raiseAnchor();

    } else {

      this.dropAnchor();
    }

  }

  /** check for geometry updates and update children as needed */
  public resize() {

    /*

    TODO:

     */
  }

  /** update the view to this regression */
  public refocus(meta: RegressionViewerMetadata) {

    Logger.debug(`[RegressionViewerComponent] rv_${this.u} refocusing: `, meta);

    this.viewer.refocus(meta);
  }

  /** clean up when closing the window */
  public close() {

    if (this.viewer === null) {

      return ;
    }

    Logger.debug('[RegressionViewerComponent] component is closing.');

    this.viewer.close();
  }


}
